import { IGpsDevice } from '@nkr/models/index';
import { ColDef, FirstDataRenderedEvent, GridReadyEvent, ICellRendererParams } from 'ag-grid-community';
import { AgGridReact } from 'ag-grid-react';
import { useMemo } from 'react';
import { Button } from 'react-bootstrap';
import styled from 'styled-components';

const GridWrapper = styled.div`
    height: 60vh;
    width: 40vw;

    border-left: 1px solid #ddd;
    border-bottom: 1px solid #ddd;

    .ag-header {
        background-color: #ddd;
    }
    
    .ag-header-cell-label {
        display: flex;
        justify-content: center;
    }

    .ag-row .ag-cell {
        display: flex;
        justify-content: center; /* align horizontal */
        align-items: center;
    }

    .ag-react-container {
        width: 100%;
    }
`;

interface IProps {
    list: IGpsDevice[],
    onEdit: (id: number) => void,
    onDelete: (id: number) => void
}

const Grid = (props: IProps) => {
    const onGridReady = (e: GridReadyEvent) => {
        e.api.sizeColumnsToFit();
    };

    const onFirstDataRendered = (e: FirstDataRenderedEvent) => {
        e.api.sizeColumnsToFit();
    };

    const columns: ColDef[] = [
        {
            colId: 'gpsNumber',
            field: 'gpsNumber',
            headerName: 'GPS #',
            width: 70,
            sortable: true,
            sort: 'asc',
            comparator: (a, b) => Number(a) - Number(b),
        },
        {
            colId: 'imei',
            field: 'imei',
            headerName: 'IMEI',
            sortable: true
        },
        {
            colId: 'vendor',
            field: 'vendor',
            headerName: 'Vendor',
            sortable: true
        },
        {
            colId: 'actions',
            width: 120,
            sortable: false,
            cellRendererFramework: (params: ICellRendererParams) => {
                return (
                    <>
                        <Button bsStyle='primary' bsSize='xs' onClick={() => props.onEdit(params.data.id)}>Edit</Button>&nbsp;
                        <Button bsSize='xs' onClick={() => props.onDelete(params.data.id)}>Delete</Button>
                    </>
                )
            }
        }
    ];

    const columnDefs = useMemo(() => columns, []);
    const rowData = useMemo(() => props.list, [props.list]);

    return (
        <GridWrapper className='ag-theme-bootstrap'>
            <AgGridReact
                defaultColDef={{
                    suppressMenu: true
                }}
                columnDefs={columnDefs}
                rowData={rowData}
                headerHeight={30}
                rowHeight={36}
                suppressCellSelection={true}
                suppressContextMenu={true}
                onGridReady={onGridReady}
                onFirstDataRendered={onFirstDataRendered}
            />
        </GridWrapper>
    );
}

export default Grid;